import { useMemo } from 'react';
import { CompanyConnection, CompanyConnectionState } from '../../../../../types/companyConnection/companyConnection';
import { FileViewLoader } from '../../../../../VentoryUI/components/common/File';
import { Company } from '../../../../../types/company';
import React from 'react';
import { FileEntityType } from '../../../../../types/file';
import { ReactComponent as VentoryWhiteLogo } from '../../../../../assets/img/Ventory-WhiteNoBack.svg';
import { VentoryColor } from '../../../../../VentoryUI/util/color.util';

interface PartnerCardProps {
  item: CompanyConnection;
  company: Company;
  onClick: () => void;
}

export default function PartnerCard({ item, company, onClick }: PartnerCardProps) {
  const logo = useMemo(() => {
    if (company.settings.companyLogo) {
      return (
        <FileViewLoader
          companyId={company.id}
          className='object-scale-down'
          fileId={company.settings.companyLogo}
          fileEntityType={FileEntityType.company}
        />
      );
    } else {
      return <VentoryWhiteLogo color={VentoryColor.grey500} stroke={VentoryColor.grey500} />;
    }
  }, []);

  const status = useMemo(() => {
    if (item.state === CompanyConnectionState.pending) {
      return <div className='h-[12px] w-[12px] animate-pulse rounded-full bg-warning-300'></div>;
    } else if (item.state === CompanyConnectionState.active) {
      return <div className='h-[12px] w-[12px] animate-pulse rounded-full bg-success-300'></div>;
    }
    return <div className='h-[12px] w-[12px] rounded-full bg-gray-300'></div>;
  }, [item.state]);

  const statusText = useMemo(() => {
    if (item.state === CompanyConnectionState.pending) return 'Pending...';
    if (item.state === CompanyConnectionState.active) return 'Active';
    return 'Inactive';
  }, [item.state]);

  return (
    <div className='h-[260px] w-[240px] border border-gray-200 px-2 pt-2 hover:cursor-pointer' onClick={onClick}>
      <div title={statusText} className='absolute h-[20px] items-center'>
        {status}
      </div>
      <div className='flex h-full flex-col items-center justify-center'>
        <div className='h-16 w-full content-center' style={{ backgroundColor: company.settings.headerColor }}>
          {logo}
        </div>
        <p className='mt-2 text-base font-medium'>{company.name}</p>
      </div>
    </div>
  );
}
